import React from 'react';
import { CheckCircle2, Circle, Store, PackagePlus, ShoppingBag } from 'lucide-react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { dashboardApi } from '../services/api';
import { formatApiError, Spinner } from '../utils/helpers';

const ICONS = { store: Store, product: PackagePlus, order: ShoppingBag };

export default function OnboardingModal({ onboarding, onNavigate, onCompleted }) {
  const completeMutation = useMutation({
    mutationFn: () => dashboardApi.completeOnboarding(),
    onSuccess: () => {
      toast.success('Selamat! Setup toko Anda sudah lengkap.');
      onCompleted();
    },
    onError: error => toast.error(formatApiError(error)),
  });
  if (!onboarding?.show) return null;

  return (
    <div data-testid="onboarding-modal" className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/45 p-4">
      <div className="w-full max-w-xl overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="bg-[#0f6c44] px-6 py-6 text-white">
          <p className="text-sm font-semibold text-emerald-100">Mulai dengan 3 langkah</p>
          <h2 className="mt-1 font-manrope text-2xl font-bold">Siapkan toko Anda</h2>
          <p className="mt-2 text-sm leading-relaxed text-emerald-50">Selesaikan checklist ini untuk mulai menerima pesanan dengan rapi.</p>
        </div>
        <div className="space-y-2 p-6">
          {(onboarding.steps || []).map((step, index) => {
            const Icon = ICONS[step.id] || Circle;
            return <button key={step.id} onClick={() => onNavigate(step.path)} data-testid={`onboarding-step-${step.id}`} className={`flex w-full items-center gap-4 rounded-xl border p-4 text-left transition-[transform,background-color,border-color] hover:-translate-y-0.5 ${step.complete ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-white hover:border-emerald-300'}`}>
              <span className={`flex h-10 w-10 flex-none items-center justify-center rounded-xl ${step.complete ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-500'}`}>{step.complete ? <CheckCircle2 size={20} /> : <Icon size={19} />}</span>
              <span className="min-w-0 flex-1"><span className="block text-sm font-bold text-slate-800">{index + 1}. {step.label}</span><span className="mt-1 block text-xs leading-relaxed text-slate-500">{step.description}</span></span>
              <span className={`text-xs font-bold ${step.complete ? 'text-emerald-700' : 'text-slate-400'}`}>{step.complete ? 'Selesai' : 'Buka'}</span>
            </button>;
          })}
        </div>
        <div className="border-t border-slate-100 px-6 py-4">
          {onboarding.completed ? <button onClick={() => completeMutation.mutate()} disabled={completeMutation.isPending} data-testid="complete-onboarding-button" className="flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-[#0f6c44] text-sm font-bold text-white transition-colors hover:bg-[#0c5636] disabled:opacity-60">{completeMutation.isPending ? <Spinner size="sm" className="border-white/30 border-t-white" /> : 'Selesai & Tutup Panduan'}</button> : <p data-testid="onboarding-progress-message" className="text-center text-xs leading-relaxed text-slate-500">Tombol tutup tersedia setelah ketiga langkah selesai.</p>}
        </div>
      </div>
    </div>
  );
}